import { isAxiosHttpError } from '@utils/service.utils';
/**
 * Base Service
 * Provides common error handling for all API services
 */
export class BaseService {
    /**
     * Handles and formats API or runtime errors into a consistent ApiError object
     */
    handleError(error, defaultMessage) {
        if (isAxiosHttpError(error)) {
            const errorData = error.response?.data;
            return {
                message: errorData?.message ||
                    errorData?.error ||
                    error.message ||
                    defaultMessage,
                status: error.response?.status,
                code: errorData?.code,
            };
        }
        if (error instanceof Error) {
            return {
                message: error.message || defaultMessage,
            };
        }
        return {
            message: defaultMessage,
        };
    }
}
